import { render, staticRenderFns } from "./AudienceEdit.vue?vue&type=template&id=3c647a93&lang=pug&"
import script from "./AudienceEdit.vue?vue&type=script&lang=js&"
export * from "./AudienceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports